/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Deep_TitleInputs */

const en_to_typescript_deep_title = /** @type {(inputs: To_Typescript_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the inference can and cannot know`)
};

const ko_to_typescript_deep_title = /** @type {(inputs: To_Typescript_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추론이 알 수 있는 것과 알 수 없는 것`)
};

const ja_to_typescript_deep_title = /** @type {(inputs: To_Typescript_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推論が知りうること、知りえないこと`)
};

/**
* | output |
* | --- |
* | "What the inference can and cannot know" |
*
* @param {To_Typescript_Deep_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_deep_title = /** @type {((inputs?: To_Typescript_Deep_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Deep_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_deep_title(inputs)
	if (locale === "ko") return ko_to_typescript_deep_title(inputs)
	return ja_to_typescript_deep_title(inputs)
});